import Vue from 'vue';
import Config from '../configuration';

export default {
    namespaced: true,
    mutations: {

    },
    getters: {

    },
    actions: {
        getClaimsModel (context, payload)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.get(Config.GetUrl(Config.kritaApi) + 'claimantClaims/' + self.state.userInfo.SelectedClaimant.ClaimantId, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getFactorableClaims (context, payload)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'claimantClaims/' + self.state.userInfo.SelectedClaimant.ClaimantId, {Current :payload.current, RowCount: payload.rowCount,Sort: payload.sort, Search: payload.search}, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getClaimantsOverdueFactorings (context, payload)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'claimantClaims/' + self.state.userInfo.SelectedClaimant.ClaimantId + '/overdue', {Current :payload.current, RowCount: payload.rowCount,Sort: payload.sort, Selection: payload.selection, Search: payload.search}, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getClaimantsActiveFactorings (context, payload)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'claimantClaims/' + self.state.userInfo.SelectedClaimant.ClaimantId + '/active', {ClaimantId: self.state.userInfo.SelectedClaimant.ClaimantId, Current :payload.current, RowCount: payload.rowCount, Sort: payload.sort, Selection: payload.selection, Search: payload.search}, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
    }
}
